import { useEffect, useState } from 'react';
import { projectDoc, projectDocs } from '@/cloud/projectDatabase';
import { getDescription, getImgURL } from '@/cloud/projectStorage';

export const useProjectHook = (state, title) => {
  const [loadDone, setLoadDone] = useState(false);
  const [data, setData] = useState(null);

  useEffect(() => {
    const loadDate = async () => {
      return state ?? (await projectDoc(title));
    };

    loadDate()
      .then((result) => setData(result))
      .finally(() => setLoadDone(true));
  }, []);

  return { loadDone, data };
};

export const useProjectImageHook = (filename) => {
  const [loadDone, setLoadDone] = useState(false);
  const [data, setData] = useState(null);

  useEffect(() => {
    getImgURL(filename)
      .then((url) => setData(url))
      .finally(() => setLoadDone(true));
  }, []);

  return { loadDone, data };
};

export const useProjectDescriptionHook = (title) => {
  const [loadDone, setLoadDone] = useState(false);
  const [data, setData] = useState(null);

  useEffect(() => {
    getDescription(`${title}.md`)
      .then((result) => setData(result))
      .finally(() => setLoadDone(true));
  }, []);

  return { loadDone, data };
};

export const useProjectListHook = () => {
  const [loadDone, setLoadDone] = useState(false);
  const [data, setData] = useState(null);

  useEffect(() => {
    projectDocs()
      .then((list) => setData(list))
      .finally(() => setLoadDone(true));
  }, []);

  return { loadDone, data };
};
